<template>
  <v-app-bar
    color="black"
    dense
    dark
    min-height="6.5vh"
    max-height="6.5vh"
    flat
    class="header-bar"
  >
    <v-menu bottom left>
      <template v-slot:activator="{ on }">
        <v-btn icon v-on="on">
          <v-icon>mdi-menu</v-icon>
        </v-btn>
      </template>
      <v-list>
        <v-list-item to="/dealers">
          <v-list-item-title>
            <v-icon>$customerManagementIcon</v-icon>
            {{ $t('navigation.dealerManagement') }}
          </v-list-item-title>
        </v-list-item>
        <v-list-item to="/admin-internal" v-if="showMyUsers">
          <v-list-item-title>
            <v-icon>$gear</v-icon>
            {{ $t('navigation.administration') }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-toolbar-title class="toolbar-logo">
      <i
        ><img
          alt="1"
          style="height: 95%; width: 160px"
          svg-inline
          src="@/assets/svg/3xSuperAdminPortalLogo.svg"
      /></i>
    </v-toolbar-title>

    <v-spacer></v-spacer>
    <AccountMenu />
  </v-app-bar>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AccountMenu from './../AccountMenu.vue'

export default defineComponent({
  name: 'InternalUserMobileNav',
  components: {
    AccountMenu,
  },
  props: {
    showMyUsers: {
      type: Boolean,
      required: true,
    },
    navTabsOptional: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    routeToDealers() {
      this.$router.push('/dealers')
    },
  },
})
</script>
